import type { Auth0ProviderOptions } from "@auth0/auth0-react";
import { getEnv } from "./env";

/**
 * Auth0Provider configuration built from VITE_AUTH0_* env vars injected at
 * build time by the deployment pipeline (CI reads them from SSM:
 * `/athena/{stage}/auth0/*`). Local dev gets them from `.env.local`.
 */
export const auth0Config: Auth0ProviderOptions = {
    domain: getEnv("VITE_AUTH0_DOMAIN"),
    clientId: getEnv("VITE_AUTH0_CLIENT_ID"),
    authorizationParams: {
        redirect_uri: typeof window !== "undefined" ? window.location.origin : "",
        audience: getEnv("VITE_AUTH0_AUDIENCE"),
    },
    cacheLocation: "localstorage",
    useRefreshTokens: true,
};

/**
 * True when the Auth0 provider has the minimum config to attempt a login.
 * When false (e.g. local dev without VITE_AUTH0_* set), wrap with a no-op
 * provider to keep the rest of the app rendering.
 */
export const auth0Configured = Boolean(auth0Config.domain && auth0Config.clientId);
